import React, {
  useCallback,
} from 'react';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  ID,
} from 'web-utils';

import {
  Button,
  EditProperty,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

type Props = {
  workoutId: number,
};

const WorkoutExercisesSubHeader = ({
  workoutId,
}: Props) => {
  const mapState = useCallback(state => ({
    workoutExercises: coreSelectors.getSortedListWorkoutExercises(
      workoutId,
      true,
    )(state),
    properties: coreSelectors.getWorkoutProperties(
      workoutId,
    )(state),
    defaultProperty: coreSelectors.getDefaultProperty(state),
  }), [workoutId]);

  const {
    properties,
    defaultProperty,
    workoutExercises,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();
  const resourceType = 'exerciseProperties';

  const handleAddProperty = () => {
    dispatch(
      coreActions.addResources({
        resourceType,
        resources: [{
          id: ID(),
          isNew: true,
          workout_id: workoutId,
          ...defaultProperty,
        }],
        list: `workout_${workoutId}`,
      }),
    );
  };

  const handleChangeProperty = (propertyId, payload) => {
    dispatch(
      coreActions.updateResources({
        resourceType,
        resources: [{
          id: propertyId,
          ...payload,
        }],
      }),
    );
  };
  const handleDeleteProperty = (propertyId) => {
    dispatch(
      coreActions.deleteResources({
        resourceType,
        resources: [{
          id: propertyId,
        }],
      }),
    );
  };

  const handleAssignProperties = () => {
    dispatch(
      coreActions.requestAssignProperties(
        workoutId,
      ),
    );
  };

  return workoutExercises.length > 1 ? (
    <S.SubHead>
      <Flex align="center" spacing={10}>
        {properties.length ? (
          <Flex align="center" spacing={10}>
            <Flex wrap="wrap">
              {properties.map(item => (
                <EditProperty
                  key={item.id}
                  initialValue={item}
                  onChange={(payload) => {
                    handleChangeProperty(item.id, payload);
                  }}
                  onDelete={() => handleDeleteProperty(item.id)}
                />
              ))}
            </Flex>
            <Button
              ghost
              appearance="primary"
              onClick={handleAssignProperties}
            >
              assign
            </Button>
          </Flex>
        ) : (
          <Text color="#ccc">
            Add metrics to multiple exercises (sets, reps, etc.)
          </Text>
        )}
        <S.Add
          onClick={handleAddProperty}
        >
          <S.PlusCircle />
        </S.Add>
      </Flex>
    </S.SubHead>
  ) : null;
};

export default WorkoutExercisesSubHeader;
